import { Model } from '@vuex-orm/core'

export default class Kompetisi extends Model {
  
    static entity = 'kompetisi'
    
    static primaryKey = 'id'

    static fields () {
        return {
            id: this.attr(null),
            area_id: this.attr(null),
            calons: this.attr([]),
            color: this.attr(null),
            contain: this.attr({}),
            desc: this.attr(null),          
            mode: this.attr(null),
            name: this.attr(null),
            pt: this.attr(null),
            sah: this.attr(null),
            status: this.attr(null),
            tahun: this.attr(null),
            tingkat: this.attr(null),
            updated_at: this.attr(null),
            updated_by: this.attr(null),
            created_at: this.attr(null),
            created_by: this.attr(null),          
            visibility: this.attr(null),
        }
    }  
}